import { api } from './'

export function fetchReports ({ school, ...body }) {
  return api.post(`/ar/${school}/reports`, body)
}
